// generated with ChatGPT
import { ChannelStore, } from '@channel-state/core';
import { useCallback, useSyncExternalStore, } from 'react';
export function createOverridableChannelStore(options) {
    const globalStore = new ChannelStore(options);
    let localOverride = {
        state: 'empty',
    };
    const subscribers = new Set();
    function getEffectiveValue() {
        return localOverride.state === 'value'
            ? localOverride.value
            : globalStore.get();
    }
    let lastValue = getEffectiveValue();
    function emitIfChanged() {
        const nextValue = getEffectiveValue();
        if (Object.is(lastValue, nextValue))
            return;
        lastValue = nextValue;
        for (const subscriber of [...subscribers]) {
            subscriber(nextValue);
        }
    }
    const unsubscribeGlobal = globalStore.subscribe(() => {
        /**
         * Any global update wins over local state.
         *
         * This also covers updates from another tab.
         */
        localOverride = {
            state: 'empty',
        };
        emitIfChanged();
    });
    const store = {
        get status() {
            return globalStore.status;
        },
        subscribeStatus: callback => globalStore.subscribeStatus(callback),
        get: () => getEffectiveValue(),
        set: value => {
            localOverride = {
                state: 'empty',
            };
            globalStore.set(value);
            /**
             * Keep this for safety in case ChannelStore.set does not synchronously
             * notify subscribers in some implementation/version.
             */
            emitIfChanged();
        },
        setLocal: value => {
            localOverride = {
                state: 'value',
                value,
            };
            emitIfChanged();
        },
        subscribe: callback => {
            subscribers.add(callback);
            /**
             * Match the useful ChannelStore behavior for app bootstrapping:
             * a subscriber immediately receives the current state.
             */
            callback(getEffectiveValue());
            return () => {
                subscribers.delete(callback);
            };
        },
        reset: async () => {
            localOverride = {
                state: 'empty',
            };
            await globalStore.reset();
            emitIfChanged();
        },
        destroy: () => {
            unsubscribeGlobal();
            subscribers.clear();
            globalStore.destroy();
        },
    };
    return store;
}
export function useOverridableChannelState(store) {
    const state = useSyncExternalStore(store.subscribe, store.get, store.get);
    const setState = useCallback((value) => {
        store.set(value);
    }, [store]);
    return [
        state,
        setState,
    ];
}
export function useOverridableChannelStatus(store) {
    return useSyncExternalStore(callback => store.subscribeStatus(callback), () => store.status, () => store.status);
}
//# sourceMappingURL=OverridableChannelStore.js.map